/* eslint-disable */
import React, { useEffect, useState } from "react";
import * as API from '../../framework/API/api'
import { Form, FormElement } from "@progress/kendo-react-form";
import { ENTITYNAME } from "../../framework/constant/constant";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useTranslation } from "../../locale/useTranslation";
import BossDialog from "../../components/BossDialog";
import ContentTreeViewForm from "./contentTreeView/ContentTreeViewForm";
import MediaEpisodeSynopsisEditForm from "./MediaEpisodeSynopsisEditForm";
import MediaEpisodeCastAndCrewEditForm from "./MediaEpisodeCastAndCrewEditForm";
import MediaExtensionEditForm from "./MediaExtensionEditForm";
import DynamicFieldsTab from "./DynamicFieldsTab";

function SeasonMetaDataEditForm(props) {

  const { dataItem, setMataData } = props;

  const [languages, setLanguages] = useState([]);
  const [pgRatings, setPGRatings] = useState([])
  const [showContentCategory, setShowContentCategory] = useState(false);
  const [categories, setCategories] = useState([]);
  const lang = useTranslation();
  const [tabNumber, setTabNumber] = React.useState(props?.tabNumber ?? "1");
  const [synopsisData, setSynopsisData] = useState(dataItem?.Synopsis ?? []);
  const [castAndCrewData, setCastAndCrewData] = useState(dataItem?.CastAndCrew ?? []);
  const [dynamicFieldData, setDynamicFieldData] = useState(dataItem?.dynamicField ?? {});
  const [extensionData, setExtensionData] = useState(dataItem?.Extension ?? {});

  useEffect(() => {
    loadcombo();
  }, []);

  const onChange = (e) => {
    setMataData({ ...dataItem, [e.target.name]: e.target.value });
  }

  const handleTabChange = (event, newValue) => {
    setTabNumber(`${newValue}`);
  };

  const loadcombo = async () => {
    let languages = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
    setLanguages(languages.data);
    let pgRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
    setPGRatings(pgRes.data);
    let categories = await API.getDataLookup(ENTITYNAME.ContentCategory, { sort: { Name: 1 } });
    setCategories(categories.data);


    setSynopsisData(dataItem?.SeasonSynopsis ?? []);
    setCastAndCrewData(dataItem?.CastAndCrew ?? []);
    setDynamicFieldData(dataItem?.dynamicField ?? {});

  }

  const handleSelectedCategories = (categories = []) => {

    if (!Array.isArray(categories) || categories.length === 0) return;

    const existingList = dataItem?.Categories || [];
    const newOnes = categories.filter(
      (cat) => !existingList.some((c) => c?._id === cat?._id)
    );

    if (newOnes.length > 0) {
      setMataData({
        ...dataItem,
        Categories: [...(dataItem?.Categories || []), ...newOnes]
      });
    }
  };

  const setSynopsis = (data) => {
    setSynopsisData(() => data)
    setMataData({
      ...dataItem,
      SeasonSynopsis: data,
    });

  }

  const setCastAndCrew = (data) => {

    setCastAndCrewData(() => data);
    setMataData({
      ...dataItem,
      CastAndCrew: data,
    });
  }

  const setDynamicField = (data) => {
    setDynamicFieldData(() => data);
    setMataData({
      ...dataItem,
      dynamicField: data,
    });
  }

  const onSaveExtension = (data) => {
    console.log(data)
    setExtensionData(() => data);
    setMataData({
      ...dataItem,
      Extension: data,
    });
  }

  return (
    <div>
      <Form
        render={(formRenderProps) => (
          <FormElement>


            <div style={{ boxShadow: "0px 0px 10px 1px lightgrey", backgroundColor: "#EEEEEE", borderRadius: "10px" }}>
              <div className="row" style={{ margin: "0px" }}>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                  <TabContext value={tabNumber}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                        <Tab label={lang.general_label} value="1" />
                        <Tab label={lang.synopsis_label} value="2" />
                        <Tab label={lang.cast_and_crew_label} value="3" />
                        <Tab label={lang.dynamic_fields_label} value="4" />
                        <Tab label={lang.extension_label} value="5" />
                      </TabList>
                    </Box>
                    <TabPanel value={"1"}>
                      <div className="pl-4 pr-3">
                        <div className="row" style={{ border: "1px solid #cbc7c7" }}>
                          <div className="col-12 mt-2">
                            <div className="row">
                              <div className="col-6">
                                <div className="form-group">
                                  <label htmlFor="">{lang.production_year_label}</label>
                                  <input type="text" className="form-control form-control-sm" name="ProductionYear" value={dataItem?.ProductionYear} onChange={(e) => onChange(e)} required />
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="form-group">
                                  <label htmlFor="TabView">{lang.pg_rating_label}</label><br />
                                  {/* old */}
                                  <DropDownList
                                    style={{
                                      backgroundColor: "white",
                                    }}
                                    data={pgRatings}
                                    name="PGRating"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem?.PGRating}
                                    onChange={onChange}
                                  />
                                  {/* new */}

                                  {/* <DynamicDropdown
                                  data={pgRatings}
                                  name="PGRating"
                                  textField="Description"
                                  dataItemKey="_id"
                                  value={dataItem?.PGRating}
                                  onChange={onChange}
                                  enityname={ENTITYNAME.PGRating}
                                defaultValue={dataItem.PGRating}
                                onChange={(value) => {
                                  setDataItem({ ...dataItem, PGRating: value })
                                  props.setMataData({ ...dataItem, PGRating: value });
                                }}
                            /> */}
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <div className="form-group">
                                  <label htmlFor="TabView">{lang.languages_label}</label>
                                  <MultiSelect
                                    data={languages}
                                    textField="Description"
                                    value={dataItem?.Languages}
                                    onChange={onChange}
                                    name={"Languages"}
                                  />
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="form-group">
                                  <label htmlFor="TabView">{lang.dubbed_languages_label}</label>
                                  <MultiSelect
                                    data={languages}
                                    textField="Description"
                                    value={dataItem?.DubbedLanguages}
                                    onChange={onChange}
                                    name={"DubbedLanguages"}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row mt-2 mb-2">
                              <div className="col-6">
                                <label>{lang.categories_label}</label>
                                <div className="d-flex">
                                  <MultiSelect
                                    dataItemKey="_id"
                                    data={categories}
                                    textField="Name"
                                    value={dataItem.Categories}
                                    onChange={onChange}
                                    name="Categories"
                                    style={{ flex: 1, marginRight: "10px" }}
                                  />
                                  <button
                                    type="button"
                                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success ms-2"
                                    style={{ width: "28px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center" }}
                                    onClick={() => setShowContentCategory(true)}
                                    title={lang.attech_media_category_button_tooltip}
                                  >
                                    <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                                  </button>
                                </div>
                              </div>
                              <div className='col-6'>
                                <div className="form-group">
                                  <label htmlFor="">{lang.keywords_label}</label>
                                  <input name="Keywords" type="text" className="form-control form-control-sm" value={dataItem?.Keywords} onChange={onChange} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>

                    <TabPanel value={"2"}>
                      <MediaEpisodeSynopsisEditForm data={synopsisData ?? []} setSynopsisData={setSynopsis} mediaData={dataItem} />
                    </TabPanel>
                    <TabPanel value={"3"}>
                      <MediaEpisodeCastAndCrewEditForm language={props?.language ?? {}} mediaData={dataItem} data={castAndCrewData ?? []} setCastAndCrew={setCastAndCrew} />
                    </TabPanel>
                    <TabPanel value={"4"}>
                      <DynamicFieldsTab dataItem={dynamicFieldData} setDynamicFieldData={setDynamicField} isLong={true}/>
                    </TabPanel>
                    <TabPanel value={"5"}>
                      <MediaExtensionEditForm item={extensionData} onChangeExtensionData={onSaveExtension} isLong={true} />
                    </TabPanel>
                  </TabContext>
                </Box>
              </div>
            </div>
            {showContentCategory &&
              <BossDialog width="50vh" title={lang.add_content_category_label} onClose={() => setShowContentCategory(false)}>
                <ContentTreeViewForm isSaveButton={true} isMultiSelect={true} onClose={() => setShowContentCategory(false)} handleSelectedCategories={handleSelectedCategories} />
              </BossDialog>}
          </FormElement>
        )} />
    </div>
  )
}

export default SeasonMetaDataEditForm;
